import React from "react"

export const tableConfigDetailUnit = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Warna Unit",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaWarnaKomersil : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeWarna : "-";
                },
                sort: false,
            },
        },
        {
            name: "noSin",
            label: "Nomor Mesin",
            options: {
                sort: false,
            },
        },
        {
            name: "noKa",
            label: "Nomor Rangka",
            options: {
                sort: false,
            },
        },
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeVariant",
            label: "Kode Variant",
            options: {
                sort: false,
            },
        },
        {
            name: "namaVariant",
            label: "Nama Variant",
            options: {
                sort: false,
            },
        },
        {
            name: "groupVariant",
            label: "Group Variant",
            options: {
                sort: false,
            },
        },
        {
            name: "qty",
            label: "Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "satuan",
            label: "Satuan",
            options: {
                sort: false,
            },
        },
        {
            name: "actQTY",
            label: "Act Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "diffQty",
            label: "Diff Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "keterangan",
            label: "Keterangan",
            options: {
                sort: false,
            },
        },
        {
            name: "aksi",
            label: "Aksi",
            options: {
                sort: false,
            },
        },
    ]
}

export const tableConfigUnitReportSO = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Warna Unit",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaWarnaKomersil : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeWarna : "-";
                },
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                sort: false,
            },
        },
        {
            name: "unitExist",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value ? "DITEMUKAN" : "TIDAK DITEMUKAN";
                },
                sort: false,
            }
        },
        {
            name: "userId",
            label: "User",
            options: {
                sort: false
            }
        }
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Warna Unit",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaWarnaKomersil : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeWarna : "-";
                },
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                sort: false,
            },
        },
        {
            name: "unitExist",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value ? "DITEMUKAN" : "TIDAK DITEMUKAN";
                },
                sort: false,
            }
        },
        {
            name: "userId",
            label: "User",
            options: {
                sort: false
            }
        }],
}

export const tableConfigUnitKelebihan = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
        },
    },
    {
        name: "dataVariant",
        label: "Kode Varian",
        options: {
            customBodyRender: (value) => {
                return value ? value.kodeVariant : "-";
            },
            sort: false,
        },
    },
    {
        name: "dataVariant",
        label: "Nama Varian",
        options: {
            customBodyRender: (value) => {
                return value ? value.namaVariant : "-";
            },
            sort: false,
        },
    },
    {
        name: "dataWarna",
        label: "Warna Unit",
        options: {
            customBodyRender: (value) => {
                return value ? value.namaWarnaKomersil : "-";
            },
            sort: false,
        },
    },
    {
        name: "dataWarna",
        label: "Kode Warna",
        options: {
            customBodyRender: (value) => {
                return value ? value.kodeWarna : "-";
            },
            sort: false,
        },
    },
    {
        name: "nomorMesin",
        label: "Nomor Mesin",
        options: {
            sort: false,
        },
    },
    {
        name: "nomorRangka",
        label: "Nomor Rangka",
        options: {
            sort: false,
        },
    },
]

export const tableConfigUnitKekurangan = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Warna Unit",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaWarnaKomersil : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeWarna : "-";
                },
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                sort: false,
            },
        },
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataVariant",
            label: "Nama Varian",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaVariant : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Warna Unit",
            options: {
                customBodyRender: (value) => {
                    return value ? value.namaWarnaKomersil : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataWarna",
            label: "Kode Warna",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeWarna : "-";
                },
                sort: false,
            },
        },
        {
            name: "nomorMesin",
            label: "Nomor Mesin",
            options: {
                sort: false,
            },
        },
        {
            name: "nomorRangka",
            label: "Nomor Rangka",
            options: {
                sort: false,
            },
        },
    ],
}
